<!--
Grade check component

This component is meant to be included within a line of text e.g. a menu item or a tab name
It does a call to the server to check if there are any overdue grades.
(It *could* potentially do other checks in the future.)
If there are, it renders a little red dot.

@author cm359n
-->
<template>
  <span class="smalldot" v-if="hasOverdue"></span>
</template>

<script>
import axios from 'axios'
import AssFeedCommon from '@/mixins/AssFeedCommon.js'
import StringUtil from '@/mixins/StringUtil.js'

export default {
  name: 'GradeCheck',
  components: {
  },
  props: {
    'initDeadlines': Array,
    'initCheckType': String
  },
  data () {
    const checkType = (typeof this.initCheckType === 'undefined' ? 'overdue' : this.initCheckType)
    return {
      deadlines: {},
      checkType: checkType,
      hasOverdue: false,
      computedHash: ''
    }
  },
  mixins: [AssFeedCommon, StringUtil],
  mounted () {
    if (typeof this.initDeadlines === 'undefined') {
      axios.get('/timetable/grades/dashboard')
        .then(response => {
          let dl = response.data
          this.deadlines = dl

          this.deadlines.forEach(a => {
            if (a.duedate === 0) {
              a.duedate = Number.MAX_SAFE_INTEGER
            }
          })

          this.checkForOverdue()
        })
    } else {
      this.deadlines = this.initDeadlines
      this.checkForOverdue()
    }
  },
  methods: {
    checkForOverdue () {
      for (const dl of this.deadlines) {
        if (this.isOverdue(dl)) {
          this.hasOverdue = true
        }
      }
    }
  }
}
</script>
<style scoped>
span.smalldot {
    height: 5px;
    width: 5px;
    background-color: red;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    left: 5px;
    top: -10px;
  }

</style>
